<template>
  <div class="ui stackable center one column divided grid">
    <div class="row">
        <h2>404 Page not found.</h2>
    </div>      
  </div>
</template>

<style scoped>
h2 {
  width: 100%;
  text-align: center;
}

.grid {
  margin: 0px!important;
  height: 200px;
  align-items: center;
}
</style>
